import { render, staticRenderFns } from "./BadgeTitle.vue?vue&type=template&id=ffa91bf2&scoped=true"
import script from "./BadgeTitle.vue?vue&type=script&lang=js"
export * from "./BadgeTitle.vue?vue&type=script&lang=js"
import style0 from "./BadgeTitle.vue?vue&type=style&index=0&id=ffa91bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa91bf2",
  null
  
)

export default component.exports